/**
 * Your account on this server and its safety (`/account`), one section each: a new password,
 * the second step of signing in, the devices signed in, what happened lately, and your data
 * (taken out as a file, or the account deleted).
 */
import type { JSX } from "solid-js";
import { AccountActivity } from "./AccountActivity";
import { AccountData } from "./AccountData";
import { AccountPassword } from "./AccountPassword";
import { AccountSecondStep } from "./AccountSecondStep";
import { AccountSessions } from "./AccountSessions";
import { usePages } from "./context";

/** The account page. */
export function AccountPage(): JSX.Element {
  const { accounts, server } = usePages();
  const me = () => accounts.me(server);
  return (
    <div class="team-page account-page" id="account-page">
      <header class="team-head">
        <h2>{me()?.account.name}</h2>
        <span class="mono small muted">{me()?.account.email}</span>
      </header>
      <AccountSecondStep />
      <AccountPassword />
      <AccountSessions />
      <AccountActivity />
      <AccountData />
    </div>
  );
}
